import { CategoryKeyEnum } from '../enum';
import { QuestionStart } from '../inteface';

export const questionsStart: QuestionStart[] = [
  // Родитель
  {
    text: 'start.questions.0',
    category: CategoryKeyEnum.Parent,
    image: 'i/1.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.1',
    category: CategoryKeyEnum.Parent,
    image: 'i/2.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.2',
    category: CategoryKeyEnum.Parent,
    image: 'i/3.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.3',
    category: CategoryKeyEnum.Parent,
    image: 'i/4.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.4',
    category: CategoryKeyEnum.Parent,
    image: 'i/5.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.5',
    category: CategoryKeyEnum.Parent,
    image: 'i/6.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.6',
    category: CategoryKeyEnum.Parent,
    image: 'i/7.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.7',
    category: CategoryKeyEnum.Parent,
    image: 'i/8.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.8',
    category: CategoryKeyEnum.Parent,
    image: 'i/9.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.9',
    category: CategoryKeyEnum.Parent,
    image: 'i/10.jpg',
    score: 0,
    skeleton: true,
  },

  // Взрослый
  {
    text: 'start.questions.10',
    category: CategoryKeyEnum.Adult,
    image: 'i/11.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.11',
    category: CategoryKeyEnum.Adult,
    image: 'i/12.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.12',
    category: CategoryKeyEnum.Adult,
    image: 'i/13.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.13',
    category: CategoryKeyEnum.Adult,
    image: 'i/14.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.14',
    category: CategoryKeyEnum.Adult,
    image: 'i/15.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.15',
    category: CategoryKeyEnum.Adult,
    image: 'i/16.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.16',
    category: CategoryKeyEnum.Adult,
    image: 'i/17.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.17',
    category: CategoryKeyEnum.Adult,
    image: 'i/18.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.18',
    category: CategoryKeyEnum.Adult,
    image: 'i/19.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.19',
    category: CategoryKeyEnum.Adult,
    image: 'i/20.jpg',
    score: 0,
    skeleton: true,
  },

  // Ребенок
  {
    text: 'start.questions.20',
    category: CategoryKeyEnum.Child,
    image: 'i/21.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.21',
    category: CategoryKeyEnum.Child,
    image: 'i/22.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.22',
    category: CategoryKeyEnum.Child,
    image: 'i/23.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.23',
    category: CategoryKeyEnum.Child,
    image: 'i/24.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.24',
    category: CategoryKeyEnum.Child,
    image: 'i/25.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.25',
    category: CategoryKeyEnum.Child,
    image: 'i/26.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.26',
    category: CategoryKeyEnum.Child,
    image: 'i/27.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.27',
    category: CategoryKeyEnum.Child,
    image: 'i/28.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.28',
    category: CategoryKeyEnum.Child,
    image: 'i/29.jpg',
    score: 0,
    skeleton: true,
  },
  {
    text: 'start.questions.29',
    category: CategoryKeyEnum.Child,
    image: 'i/30.jpg',
    score: 0,
    skeleton: true,
  },
];
